/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ServiceTeam {
    TruckLoad = 1,
    Brokerage = 2,
    Dedicated = 3,
    Expedite = 4,
    TLBrokerage = 5,
    Specialized = 6,
    NotCommmitted = 7,
    CrossDock = 8,
    AirRevenue = 9,
}
